"use strict";

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HooksHelper = void 0;

var react_1 = require("react");

function useStateBuilder(initialState) {
  var _react_1$useState = react_1.useState(initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      value = _react_1$useState2[0],
      set = _react_1$useState2[1];

  return {
    value: value,
    set: set
  };
}

exports.HooksHelper = {
  useStateBuilder: useStateBuilder
};